export default {
    showPatientOperationsTable ({commit}) {
        commit('showPatientOperationsTable');
    },

    showOperationEkatForm ({commit}) {
        commit('showOperationEkatForm');
    },
}
